import React, { PropsWithChildren } from 'react';
import { TimelineContextValue, TimelineProviderProps } from './types';
import { useTimelineContextManager } from './useTimelineContextManager';

export const TimelineContext = React.createContext<TimelineContextValue | null>(
  null,
);

export function useTimeline(): TimelineContextValue {
  const context = React.useContext(TimelineContext);
  if (!context) {
    throw new Error('useTimeline must be used within a TimelineProvider');
  }
  return context;
}

/**
 * Place the TimelineProvider at the root of the view nearest where you will use the timeline yet want
 * state related to the timeline to be shared.
 */
export function TimelineProvider(
  props: PropsWithChildren<TimelineProviderProps>,
): React.ReactElement {
  const { children } = props;
  const value = useTimelineContextManager(props);

  return (
    <TimelineContext.Provider value={value}>
      {children}
    </TimelineContext.Provider>
  );
}
